import { render, staticRenderFns } from "./ApprovalStagesTable.vue?vue&type=template&id=3bc68598"
import script from "./ApprovalStagesTable.vue?vue&type=script&lang=js"
export * from "./ApprovalStagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports